import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input, InputGroup, InputGroupText } from 'reactstrap';
import Select, { MultiValue } from 'react-select';
import { OrderStatus, OrderType } from 'models/Order';

type OrderFilterProps = {
  setFilterStatus: (value: OrderStatus[]) => void;
  setFilterType: (value: OrderType[]) => void;
  setFilterTerm: (value: string) => void;
};

export const OrderFilters = (props: OrderFilterProps) => {
  const { t } = useTranslation('translation');

  const typeOptions = [
    { value: OrderType.Education, label: t('orders.TYPE_Education') },
    { value: OrderType.Group, label: t('orders.TYPE_Group') },
    { value: OrderType.Individual, label: t('orders.TYPE_Individual') },
  ] as FilterTypeOption[];

  const statusOptions = [
    { value: OrderStatus.Booked, label: t('orders.STATUS_Booked') },
    { value: OrderStatus.ForDelivery, label: t('orders.STATUS_ForDelivery') },
    { value: OrderStatus.PartnerBooked, label: t('orders.STATUS_PartnerBooked') },
    { value: OrderStatus.Cancelled, label: t('orders.STATUS_Canceled') },
    { value: OrderStatus.Planning, label: t('orders.STATUS_Planning') },
    { value: OrderStatus.WaitingForCustomer, label: t('orders.STATUS_WaitingForCustomer') },
  ] as FilterStatusOption[];

  const updateFilterTerm = (event: React.KeyboardEvent<HTMLInputElement>) => {
    props.setFilterTerm(event.currentTarget.value);
  };

  const updateFilterStatus = (value: MultiValue<FilterStatusOption>) => {
    const newFilterStatus = value.map((option) => option.value);
    props.setFilterStatus(newFilterStatus);
  };

  const updateFilterType = (value: MultiValue<FilterTypeOption>) => {
    const newFilterType = value.map((option) => option.value);
    props.setFilterType(newFilterType);
  };

  return (
    <div className="row">
      <div className="col-lg-4 col-12">
        <InputGroup className="search-container">
          <Select
            options={statusOptions}
            isMulti
            placeholder={t('orders.FILTER_SELECT_STATUS')}
            className="filter-select"
            getOptionLabel={(option) => option.label}
            onChange={updateFilterStatus}
          />
        </InputGroup>
      </div>
      <div className="col-lg-4 col-12">
        <InputGroup className="search-container">
          <Select
            options={typeOptions}
            isMulti
            placeholder={t('orders.FILTER_SELECT_TYPE')}
            className="filter-select"
            getOptionLabel={(option) => option.label}
            onChange={updateFilterType}
          />
        </InputGroup>
      </div>

      <div className="col-lg-4 col-12">
        <InputGroup className="search-container">
          <InputGroupText>
            <i className="fa fa-search" />
          </InputGroupText>
          <Input placeholder={t('orders.SEARCH')} onKeyUp={updateFilterTerm} />
        </InputGroup>
      </div>
    </div>
  );
};

type FilterStatusOption = {
  value: OrderStatus;
  label: string;
};

type FilterTypeOption = {
  value: OrderType;
  label: string;
};
